import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Register() {
    const { signup } = useAuth();
    const navigate = useNavigate();
    const [data, setData] = useState({ name: "", email: "", password: "", phone: "" });
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const u = await signup(data);
            toast.success(`Welcome to X-Plosiv, ${u.name}`);
            navigate(u.role === "admin" ? "/admin" : "/");
        } catch (e) {
            toast.error(e.response?.data?.detail || "Sign up failed");
        } finally { setLoading(false); }
    };

    return (
        <div className="max-w-md mx-auto px-6 py-2" data-testid="register-page">
            <div className="dw-section p-8">
                <h1 className="font-display text-4xl">Create account.</h1>
                <p className="text-muted-foreground mt-2 text-sm">Create an account to keep your event activity together.</p>
                <form onSubmit={submit} className="mt-7 space-y-4">
                    <div>
                        <Label className="font-mono-ui mb-2 block">Name</Label>
                        <Input required value={data.name} onChange={(e) => setData(d => ({ ...d, name: e.target.value }))} className="rounded-2xl bg-white/70 border-[#E7DED2] h-11" data-testid="register-name-input" />
                    </div>
                    <div>
                        <Label className="font-mono-ui mb-2 block">Email</Label>
                        <Input type="email" required value={data.email} onChange={(e) => setData(d => ({ ...d, email: e.target.value }))} className="rounded-2xl bg-white/70 border-[#E7DED2] h-11" data-testid="register-email-input" />
                    </div>
                    <div>
                        <Label className="font-mono-ui mb-2 block">Phone (optional)</Label>
                        <Input value={data.phone} onChange={(e) => setData(d => ({ ...d, phone: e.target.value }))} className="rounded-2xl bg-white/70 border-[#E7DED2] h-11" data-testid="register-phone-input" />
                    </div>
                    <div>
                        <Label className="font-mono-ui mb-2 block">Password</Label>
                        <Input type="password" required minLength={6} value={data.password} onChange={(e) => setData(d => ({ ...d, password: e.target.value }))} className="rounded-2xl bg-white/70 border-[#E7DED2] h-11" data-testid="register-password-input" />
                    </div>
                    <button type="submit" disabled={loading} className="w-full dw-btn-primary h-12 font-mono-ui" data-testid="register-submit-button">{loading ? "Creating…" : "Create account"}</button>
                </form>
                <p className="mt-6 text-center text-sm">Already have an account? <Link to="/login" className="underline">Sign in</Link></p>
            </div>
            <div className="h-24" />
        </div>
    );
}
